<script>
  /**
   * Bulma で Form を作る際の Field コンポーネント
   * @see https://bulma.io/documentation/form/general
   */
  export let id
  export let label
  export let isLoading = false
</script>

<div class="field">
  <label class="label" for={id}>{label}</label>
  <div
    class="control"
    data-testid={`${id}Control`}
    class:is-loading={isLoading}
  >
    <slot />
  </div>
</div>
